import api from "../api/axiosInstance";
import axios from "axios";

const documentService = {
  upload: async (shipmentId, files, type = "other", onProgress, itemId) => {
    // Step 1: get presigned URLs
    const { data: presignData } = await api.post(
      `/documents/presign/${shipmentId}`,
      {
        files: files.map((f) => ({ name: f.name, type: f.type, size: f.size })),
      },
    );
    const presignedFiles = presignData.data.files;

    // Step 2: upload each file directly to S3, tracking combined progress
    const totalSize = files.reduce((sum, f) => sum + f.size, 0);
    const loadedByIndex = new Array(files.length).fill(0);

    const reportProgress = () => {
      if (!onProgress) return;
      const loaded = loadedByIndex.reduce((sum, v) => sum + v, 0);
      const pct = Math.round((loaded * 100) / totalSize);
      onProgress(pct);
    };

    await Promise.all(
      presignedFiles.map((pf, idx) =>
        axios.put(pf.url, files[idx], {
          headers: { "Content-Type": pf.mimeType },
          onUploadProgress: (e) => {
            loadedByIndex[idx] = e.loaded;
            reportProgress();
          },
        }),
      ),
    );

    // Step 3: finalize — create Document records now that files are actually in S3
    return api.post(`/documents/finalize/${shipmentId}`, {
      type,
      itemId,
      files: presignedFiles.map((pf) => ({
        originalName: pf.originalName,
        key: pf.key,
        mimeType: pf.mimeType,
        size: pf.size,
      })),
    });
  },

  getForShipment: (shipmentId) => api.get(`/documents/shipment/${shipmentId}`),

  download: (docId) => api.get(`/documents/${docId}/download`),

  // Same presigned URL, but the server sets Content-Disposition: inline —
  // opens/renders in the browser tab instead of forcing a save-to-disk
  // prompt. Used by the "View" button.
  view: (docId) => api.get(`/documents/${docId}/download`, { params: { mode: "inline" } }),

  verify: (docId, notes) => api.patch(`/documents/${docId}/verify`, { notes }),

  delete: (docId) => api.delete(`/documents/${docId}`),
};

export default documentService;